import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'app-source-fund-en-v2',
    templateUrl: './source-fund-en-v2.component.html',
    styleUrls: ['./source-fund-en-v2.component.css'],
    standalone: false
})
export class SourceFundEnV2Component implements OnInit, OnChanges {
  @Input() printActive: boolean
  @Input() returnData: any
  @Input() isSinglePageReturn: boolean
  otherReceipt = [];
  taxExemptedIncome = [];
  taxableIncome;
  isSourceFund = false;

  constructor() { }

  exemptedField = [
    { key: 'poti_IFA_EXEMPTED_Amt', desc: 'Agriculture' },
    { key: 'poti_IFB_EXEMPTED_Amt', desc: 'Business' },
    { key: 'poti_IFCG_EXEMPTED_Amt', desc: 'Capital Gains' },
    { key: 'poti_IFEMP_EXEMPTED_Amt_with_deemed', desc: 'Salary' },
    { key: 'poti_IFFA_EXEMPTED_Amt', desc: 'Financial Assets' },
    { key: 'poti_IFOS_EXEMPTED_Amt', desc: 'Other Sources' },
    { key: 'poti_IFR_EXEMPTED_Amt', desc: 'Rent' },
    { key: 'poti_PENALTY_EXEMPTED_Income', desc: 'Penalty' },
    // { key: 'poti_TAX_EXEMPTED_Amt', desc: 'Tax Exempted' },
  ];

  teiTypeMap: { [key: string]: string } = {
    "foreign_remittance": "Foreign Remittance",
    "software_and_it_business": "Software and IT Business",
    "tax_exempted_bond_or_securities": "Income from Tax Exempted Bond or Securities",
    "government_welfare_allowance": "Welfare Allowance from Government/Muktijhoddha Kallyan Trust",
    "rewards_from_government": "Rewards from Government",
    "income_from_old_home": "Income from Old Home",
    "income_from_prize": "Income from Prize",
    "income_from_pension": "Income from Pension",
    "universal_pension_scheme": "Universal Pension Scheme",
    "other_exemption_under_sixth_schedule_part_a": "Other Exemption under 6th Schedule Part 1",
    "other_exemption_by_sro": "Exemption by SRO"
  };

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    this.nonCashBenefitView();
    this.taxExemptedIncome = [];
    this.otherReceipt = [];
    this.taxableIncome = this.returnData?.taxPaymentData?.poti_Total_Income_Amt_with_deemed || 0;
    this.isSourceFund = false;
    this.getAssetDetails();
    this.getTaxExemptedIncome();

    if (this.taxExemptedIncome[0]?.description !== '-' || this.otherReceipt[0]?.description !== '-' || this.taxableIncome > 0) {
      this.isSourceFund = true;
    }
  }

  nonCashBenefitView(): void {
    let income=this.returnData?.taxPaymentData?.poti_Total_Income_Amt
    let exempted=this.returnData?.taxPaymentData?.poti_IFEMP_EXEMPTED_Amt
    let deed=this.returnData?.taxPaymentData?.poti_DEEMED_Amt ?? 0

    if(income>deed){
       income-= deed;
    }else{
      exempted -= (deed-income);
      income=0;
    }

    if (this.returnData?.taxPaymentData) {
      this.returnData.taxPaymentData.poti_Total_Income_Amt_with_deemed = income;
      this.returnData.taxPaymentData.poti_IFEMP_EXEMPTED_Amt_with_deemed = exempted;
    }
  }

  getAssetDetails() {

    this.returnData?.headSummery?.assetsAndLiabilities?.forEach(item => {

      if (item.typeKey === "sources_of_fund") {

        if (item.firstSubTypeKey === "other_receipts") {
          this.otherReceipt = this.otherReceipt.concat(item.detailsOfAL)
        }
      }
    })

    if (this.otherReceipt.length === 0) {
      this.otherReceipt.push({ description: '-', value: 0 });
    }
  }


  getTaxExemptedIncome() {
    const item = this.returnData?.taxPaymentData;

    this.exemptedField.forEach(f => {
      if (item[f.key] > 0) {
        this.taxExemptedIncome = this.taxExemptedIncome.concat({
          value: item[f.key],
          description: f.desc
        });
      }
    });

    const teiDetails = this.returnData?.detailReturnView?.teiDetails || [];
    teiDetails.forEach(tei => {
        this.taxExemptedIncome.push({
          value: tei.TEI_TAX_EXEMPTED_INCOME,
          description: this.teiTypeMap[tei.TEI_TYPE]
        });
    });

    if (this.taxExemptedIncome.length === 0) {
      this.taxExemptedIncome.push({ value: 0, description: '-' });
    }

  }


}


